import RootPage from './charts.page.vue'

let routes = [
  {
    path: 'charts',
    name: 'charts',
    component: RootPage
  },
]

export default routes
